import React, { useState } from "react";
import { withRouter } from "react-router-dom";

import * as Yup from "yup";
import { Formik, Field } from "formik";

import AuthenticationAPI from "../../api/AuthenticationAPI";

import Alert from "@material-ui/lab/Alert";
import Button from "../../components/Button";
import { textField } from "../../components/Form";
import Separator from "../../components/Separator";

import WaitValidatidateAuth from "./loadingValidateAuth";

import "./index.css";

const Login = ({ history }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState("");

    const LoginValidation = Yup.object({
        username: Yup.string()
            .required("Username is required"),
        password: Yup.string()
            .required("Password is required")
    });

    const submitAPIAuthentication = body => {
        setIsLoading(true);

        AuthenticationAPI.login(body)
            .then(res => {
                localStorage.setItem("access_token", res.data.accessToken);

                history.push("/dashboard");
            })
            .catch(err => {
                setIsError(err.response.data.message);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    if (isLoading) return <WaitValidatidateAuth />;

    return (
        <div className="page-container">
            <div className="body-content ">
                <div className="container-reset-password">
                    <div className="wrap-reset-password">
                        <span className="reset-password-title">
                            Login
                        </span>
                        {isError && (
                            <Alert severity="error">
                                {isError}
                            </Alert>
                        )}
                        <Separator variant="vertical" />

                        <Formik
                            initialValues={{
                                username: "",
                                password: ""
                            }}
                            validationSchema={LoginValidation}
                            onSubmit={submitAPIAuthentication}
                        >
                            {props => (
                                <>
                                    <div>
                                        <Field
                                            name="username"
                                            placeholder="Username"
                                            disabled={isLoading}
                                            component={textField}
                                        />
                                    </div>
                                    <Separator variant="vertical" />

                                    <div>
                                        <Field
                                            type="password"
                                            name="password"
                                            placeholder="Password"
                                            disabled={isLoading}
                                            component={textField}
                                        />
                                    </div>
                                    <Separator variant="vertical" size={40} />

                                    <div
                                        style={{
                                            display: "flex",
                                            // flexDirection: "row",
                                            justifyContent: "space-between"
                                        }}
                                    >
                                        <div>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                disabled={isLoading}
                                                style={{
                                                    color: "#fff",
                                                    fontSize: "15px",
                                                    lineHeight: "1.2",
                                                    fontFamily: "Poppins",
                                                    height: "40px",
                                                    padding: "0 20px"
                                                }}
                                                onClick={props.handleSubmit}
                                            >
                                                Login
                                            </Button>
                                        </div>
                                    </div>
                                </>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withRouter(Login);